export default __webpack_public_path__ + "static/085-37892eef5ee629a081931976855e9efd.jpg";